import { c as _c } from "react/compiler-runtime";
import type { BaseChildProps } from './type';
function BaseStepItem(t0) {
  const $ = _c(2);
  const {
    value,
    activeStep,
    children
  } = t0;
  if (value !== activeStep) {
    return null;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default BaseStepItem;